import React, { useState } from "react";
import { TContentHubSeriesDetailsProps } from "../types/ContentHubSeriesDetails.type";
import LazySection from "../../../react-only-components/LazySection";
import ExperienceEditorComponentPlaceholder from "../../../react-only-components/ExperienceEditorComponentPlaceholder";
import ComponentDetails from "./ComponentDetails";
import { SeriesDetailsModel } from "../models/ContentHubSeriesDetails.model";

const ContentHubSeriesDetails = (props: TContentHubSeriesDetailsProps) => {
  const isEEActive = props?.sitecoreContext?.pageEditing;
  const isPreview = props?.sitecoreContext?.pageState === "preview";
  const isPlaceholderShown = isEEActive || isPreview;
  const model = new SeriesDetailsModel(props);
  const [selectedComponent, setSelectedComponent] = useState(
    model?.innerComponents?.length && model?.innerComponents[0]
      ? model?.innerComponents[0]
      : null
  );

  return (
    <LazySection>
      {isPlaceholderShown ? (
        <ExperienceEditorComponentPlaceholder text="Content Hub Series Details - Component Placeholder" />
      ) : (
        <section
          className="series-details"
          id={props?.fields?.apiData?.id?.toString()}
        >
          <div className="series-details__container">
            <div>
              <div className="series-details__header">
                {model?.eyebrow && (
                  <div className="series-details__eyebrow">
                    {model?.eyebrow}
                  </div>
                )}
                {model?.title && (
                  <h1 className="series-details__title">{model?.title}</h1>
                )}
                {model?.description && (
                  <p className="series-details__description">
                    {model?.description}
                  </p>
                )}
              </div>
              <ul className="series-details__tabs">
                {model?.innerComponents?.map((component, index) => (
                  <li className="series-details__tab" key={`${index} `}>
                    <button
                      className={`series-details__tab-button ${
                        selectedComponent?.id === component.id
                          ? "series-details__tab-button--selected"
                          : ""
                      }`}
                      onClick={() => {
                        setSelectedComponent(component);
                      }}
                    >
                      <span>{component.eyebrow}</span>
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <section>
              {selectedComponent && (
                <ComponentDetails
                  component={selectedComponent}
                  className="series-details__component"
                />
              )}
            </section>
          </div>
        </section>
      )}
    </LazySection>
  );
};

export default ContentHubSeriesDetails;
